import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



import { CardDetailsModule } from '../card-details/card-details.module';
import { CardComponent } from './card.component';
import { AvatarModule } from '../avatar/avatar.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ProgressBarComponent } from './card-progress/card-progress.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [CardComponent],
  imports: [
    CommonModule,
    CardDetailsModule,
    AvatarModule,
    ProgressBarComponent,
    PipesModule,
    MatIconModule,

  ],
  exports: [CardComponent],
})
export class CardModule {}
